<template>
    <footer class="footer">
        <div class="wrap clearfix">
            <p class="copyright">Copyright © 2018. All Rights Reserved by Rijihua. Privacy Policy Terms of Use Feedback from the website? click here</p>
            <p>粤ICP备12022215号-11</p>
        </div>
    </footer>
</template>
<script type="text/javascript">
export default {
    data(){
        return{
            
        }
    },
}
</script>
<style lang="less" scoped>
.footer{
    position: relative;
    overflow: hidden;
    background-color: #323232;
    height: 170px;
    font-size: 12px;
    color: #ccc;
    text-align: center;
    .copyright{
        margin: 60px 0 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue